import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ClipboardModule } from 'ngx-clipboard';
import { ProfileCardComponent } from './profile-card.component';

@NgModule({
  imports: [CommonModule, ClipboardModule],
  exports: [ProfileCardComponent],
  declarations: [ProfileCardComponent],
})
export class ProfileCardModule {}
